// extracted by mini-css-extract-plugin
module.exports = {"renderTitle":"style_renderTitle__109Tp","title":"style_title__pchcl","rolePermissionModal":"style_rolePermissionModal__3kZ6n"};